import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
  computed,
  WritableSignal,
  signal,
  effect,
} from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TimePicker } from 'libs/shared/components/ui/time-picker/time-picker';
import { SchemaMembershipStateService } from 'libs/core';

@Component({
  selector: 'lib-schedule-calendar-day-edit',
  imports: [CommonModule, NgClass, ReactiveFormsModule, TimePicker],
  templateUrl: './schedule-calendar-day-edit.html',
  styleUrl: './schedule-calendar-day-edit.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleCalendarDayEdit {
  
  schemaState = inject(SchemaMembershipStateService);

  control = input.required<FormControl>();
  day = input.required<Date>();

  isCurrentMonth = computed(() =>{
    return this.day().getMonth() === (new Date()).getMonth();
  })

  private startOfDay(d: Date) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  isToday = computed(() =>
    this.startOfDay(this.day()).getTime() === this.startOfDay(new Date()).getTime()
  );

  isPast = computed(() =>
    this.startOfDay(this.day()).getTime() <= this.startOfDay(new Date()).getTime()
  );

  isDisabled = computed(() => {
    // El pare ja aplica el marge i hourLimit quan crea el FormControl.
    return this.control().disabled;
  });
  
}
